<template>
    <!-- Admin → Tableros personales (/admin/tableros, /admin/tableros/:id).
         Cada admin arma sus tableros (columnas con color + tarjeta de ejemplo que
         hace de molde) y decide con quién compartirlos. Diseño = demo aprobada
         (OneDrive\Desktop\crm-equipo); la pantalla la dibuja tablerosApp.js y los
         estilos salen de la demo (tableros.css, generado) + tablerosFront.css.
         Datos y permisos: TablerosController (admin/tableros…, módulo `tableros`). -->
    <div ref="raiz" class="tp"></div>
</template>

<script>
import axios from 'axios';
import { montar } from './tablerosApp';

const BASE = () => `${process.env.VUE_APP_API_URL}admin/tableros`;
/** Errores de axios → { status, data } (lo que espera el motor). */
const fallo = e => { const r = e && e.response; throw { status: r ? r.status : 0, data: r ? r.data : null }; };
const api = {
    get: r => axios.get(BASE() + r).then(x => x.data, fallo),
    post: (r, b) => axios.post(BASE() + r, b || {}).then(x => x.data, fallo),
    put: (r, b) => axios.put(BASE() + r, b || {}).then(x => x.data, fallo),
    del: r => axios.delete(BASE() + r).then(x => x.data, fallo),
    subir: (r, fd) => axios.post(BASE() + r, fd).then(x => x.data, fallo),
    blob: r => axios.get(BASE() + r, { responseType: 'blob' }).then(x => x.data, fallo),
};

export default {
    name: 'TablerosPersonales',
    mounted() {
        this.app = montar(this.$refs.raiz, {
            api,
            navegar: id => {
                const destino = id === 'admin' ? '/admin' : id ? `/admin/tableros/${id}` : '/admin/tableros';
                if (this.$route.fullPath !== destino) this.$router.push(destino).catch(() => {});
            },
        });
        this.ir();
        // La pantalla arranca pegada al header del sitio: se descuenta el padding de
        // arriba del layout (60 px) y se mide el alto real del header (--top).
        this._alto = () => this.ajustarAlto();
        this.ajustarAlto();
        this.$nextTick(this._alto);
        window.addEventListener('resize', this._alto);
    },
    watch: {
        $route() { this.ir(); },
    },
    beforeRouteLeave(to, from, next) {
        if (this.app && this.app.sucio() && !window.confirm('Tienes cambios sin guardar en la tarjeta. ¿Salir igual?')) { next(false); return; }
        next();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._alto);
        if (this.app) this.app.destruir();
    },
    methods: {
        ajustarAlto() {
            const el = this.$refs.raiz; if (!el) return;
            const cont = el.closest('.main-content');
            const pad = cont ? parseFloat(getComputedStyle(cont).paddingTop) || 0 : 0;
            const hdr = document.querySelector('.app-header');
            el.style.marginTop = (-pad) + 'px';
            if (hdr) el.style.setProperty('--top', Math.round(hdr.getBoundingClientRect().height) + 'px');
        },
        ir() {
            if (this.$route.name !== 'admin-tableros') return;
            this.app.ir(this.$route.params.id, this.$route.query.tarjeta);
        },
    },
};
</script>

<style src="./tableros.css"></style>
<style src="./tablerosFront.css"></style>
<style src="./tablerosExtra.css"></style>
